import React, { useState, useEffect, useRef } from "react";

import Header from "../components/Header";
import Footer from "../components/Footer";
import rocket from "../assets/images/rocket.png";
import { toast } from "react-toastify";
import ApiService from "../services/ApiService";
import decoration from "../assets/images/decoration.png";
import { useTranslation } from "react-i18next";
import "../assets/css/talentSearch.css";
import { Col, Row, Button, Container } from "react-bootstrap";
import { LiaDownloadSolid } from "react-icons/lia";
import LocationDot from "../assets/images/location.png";
import { User } from "lucide-react";
import Image from "../components/Image";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import { MultiSelect } from "react-multi-select-component";
import { Form, Link } from "react-router-dom";
import Lottie from "lottie-react";
import NoResultAnimation from "../assets/animations/No Result Green theme.json";
import Select, { components } from "react-select";

// Format date as MM-DD-YYYY for the API
const formatShortDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const year = d.getFullYear();
  return `${month}-${day}-${year}`;
};

const SearchTalent = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedTalentIds, setSelectedTalentIds] = useState([]);
  const [selectedTalentData, setSelectedTalentData] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [talentsData, setTalentsData] = useState([]);
  const [filters, setFilters] = useState({
    skills: [],
    availability: ["", ""],
    nationality: "",
    ageRange: "",
    ageSort: "",
  });
  const [showPopup, setShowPopup] = useState(false);

  // Talent results
  const [talents, setTalents] = useState([]);
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const [scrollX, setScrollX] = useState(0);
  const toggleTalent = (id, talent) => {
    setSelectedTalentIds((prev) =>
      prev.includes(id) ? prev.filter((tid) => tid !== id) : [...prev, id],
    );

    setSelectedTalentData((prev) => {
      const isSelected = selectedTalentIds.includes(id);

      if (isSelected) {
        // Remove the talent by ID
        return prev.filter((t) => t._id !== id);
      } else {
        // Add the selected talent
        return [...prev, talent];
      }
    });
  };
  const [expandedTalentIds, setExpandedTalentIds] = useState([]);
  const toggleReadMore = (id) => {
    setExpandedTalentIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const moveX = scrollPosition * 0.5;
      setScrollX(moveX);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const svgRef = useRef(null);
  const pathRef = useRef(null);

  useEffect(() => {
    const svg = svgRef.current;
    const path = pathRef.current;

    if (!svg || !path) return;

    const scroll = () => {
      const distance = window.scrollY;
      const totalDistance = svg.clientHeight - window.innerHeight;
      console.log(totalDistance);
      const percentage = distance / totalDistance;
      const pathLength = path.getTotalLength();

      path.style.strokeDasharray = `${pathLength}`;
      path.style.strokeDashoffset = `${pathLength * (1 - percentage)}`;
    };

    scroll();
    window.addEventListener("scroll", scroll);

    return () => {
      window.removeEventListener("scroll", scroll);
    };
  }, []);

  const { t, i18n } = useTranslation();

  useEffect(() => {
    const currentLang = i18n.language;
    const direction = currentLang === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", direction);
    document.documentElement.setAttribute("lang", currentLang);
  }, [i18n.language]);

  const [cardData, setCardData] = useState([]);

  // useEffect(() => {
  //   const fetchTalents = async () => {
  //     try {
  //       const response = await ApiService.get("getTalents");
  //       const talents = response.data?.data?.talents || [];
  //       setTalentsData(response.data?.data?.talents)
  //       console.log(',mamsm', response.data?.data?.talents)
  //       const mappedTalents = talents.map((talent) => {
  //         const skillTitles = (talent.skills || [])
  //           .map((s) => s.skill_id?.title)
  //           .filter(Boolean);

  //         const skillIds = (talent.skills || [])
  //           .map((s) => s.skill_id?._id)
  //           .filter(Boolean);

  //         const role = skillTitles.join(", ") || "No skills provided";

  //         return {
  //           image:
  //             talent.picture ||
  //             "https://sky.devicebee.com/Nahham/api/public/uploads//blank.png",
  //           name: talent.first_name || "N/A",
  //           overlayName: talent.last_name || "N/A",
  //           location: talent.country || "N/A",
  //           description: talent.about || "No description available",
  //           role,
  //           skillIds, // include skill IDs for exact filtering
  //         };
  //       });

  //       setCardData(mappedTalents);
  //     } catch (error) {
  //       console.error("Failed to fetch talents:", error);
  //     }
  //   };

  //   fetchTalents();
  // }, []);
  // const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchSkills = async () => {
    try {
      setLoading(true);
      const res = await ApiService.request({
        method: "GET",
        url: "/getSkills",
      });

      const data = res.data;
      console.log("Skills response:", data);

      if (data.status && data.data?.skills) {
        setSkills(data.data.skills);
      } else {
        toast.error(data.message || "Failed to fetch skills");
      }
    } catch (error) {
      toast.error("Something went wrong while fetching skills");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSkills();
  }, []);

  const [skills, setSkills] = useState([]);
  const [positionId, setPositionId] = useState("");

  const [availabilitySearch, setAvailabilitySearch] = useState("");
  const [experienceSearch, setExperienceSearch] = useState("");
  const [locationSearch, setLocationSearch] = useState("");

  const [selectedAvailability, setSelectedAvailability] = useState(null);
  const [selectedExperience, setSelectedExperience] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [nationality, setNationality] = useState("");
  const [ageRange, setAgeRange] = useState("");
  const [ageSort, setAgeSort] = useState("");

  const handleSave = (type, id, title) => {
    localStorage.setItem(type, id);

    switch (type) {
      case "position":
        setPositionId(id);
        break;
      case "availability":
        setSelectedAvailability(title);
        setAvailabilitySearch("");
        break;
      case "experience":
        setSelectedExperience(title);
        setExperienceSearch("");
        break;
      case "location":
        setSelectedLocation(title);
        setLocationSearch("");
        break;
      case "nationality":
        setNationality(id); // <-- store in state
        break;
      case "ageRange":
        setAgeRange(id);
        break;
      case "ageSort":
        setAgeSort(id);
        break;
      default:
        break;
    }
  };

  const [filteredCards, setFilteredCards] = useState([]);
  // const handleSearch = () => {
  //   console.log("printer")
  //   const filtered = cardData.filter((card) => {
  //     const matchesPosition = !positionId || card.skillIds.includes(positionId);
  //     const matchesAvailability =
  //       !selectedAvailability ||
  //       skills.find(
  //         (s) =>
  //           s.title === selectedAvailability && card.skillIds.includes(s._id)
  //       );
  //     const matchesExperience =
  //       !selectedExperience ||
  //       skills.find(
  //         (s) => s.title === selectedExperience && card.skillIds.includes(s._id)
  //       );
  //     const matchesLocation =
  //       !selectedLocation ||
  //       card.location.toLowerCase().includes(selectedLocation.toLowerCase());

  //     return (
  //       matchesPosition &&
  //       matchesAvailability &&
  //       matchesExperience &&
  //       matchesLocation
  //     );
  //   });

  //   setFilteredCards(filtered);
  // };
  const handleClearFilters = () => {
    const clearedFilters = {
      skills: [],
      availability: ["", ""],
      nationality: "",
      ageRange: "",
      ageSort: "",
    };
    setFilters(clearedFilters);
    fetchTalents(clearedFilters);
  };
  const handleDownload = (url, filename) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename || "resume.png");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getSkillTitle = (id) => {
    const skill = skills.find((s) => s._id === id);
    return skill?.title.toLowerCase() || "";
  };

  const fetchTalents = async (filterParams = {}) => {
    try {
      setIsLoading(true);

      const parts = [];

      // Nationality (maps from state key `nationality`)
      if (filterParams.nationality?.trim()) {
        parts.push(
          `nationality=${encodeURIComponent(filterParams.nationality.trim())}`,
        );
      }

      // Availability — only append if both dates exist
      if (filterParams.availability?.[0] && filterParams.availability?.[1]) {
        parts.push(`availability[0]=${filterParams.availability[0]}`);
        parts.push(`availability[1]=${filterParams.availability[1]}`);
      }

      // Skills
      if (
        Array.isArray(filterParams.skills) &&
        filterParams.skills.length > 0
      ) {
        parts.push(`skills=${filterParams.skills.join(",")}`);
      }

      // Age range (maps from `ageRange`)
      if (filterParams.ageRange?.trim()) {
        parts.push(`age=${encodeURIComponent(filterParams.ageRange.trim())}`);
      }

      // Sort by age (maps from `ageSort`)
      if (filterParams.ageSort?.trim()) {
        parts.push(`sort_age=${filterParams.ageSort.trim()}`);
      }

      // Build final URL
      const queryString = parts.length ? `?${parts.join("&")}` : "";
      const finalUrl = `/getTalents${queryString}`;

      const response = await ApiService.request({
        method: "GET",
        url: finalUrl,
      });

      if (response.status === 200) {
        const talents = response.data?.data?.talents || [];
        setTalentsData(talents);
      }
    } catch (error) {
      console.error("Failed to fetch talents:", error);
      toast.error("Failed to load talents.");
    } finally {
      setIsLoading(false);
    }
  };

  // On mount → fetch all talents
  useEffect(() => {
    fetchTalents();
  }, []);

  // On Search button click → fetch with filters
  const handleSearch = () => {
    fetchTalents(filters);
  };
  const isRTL = i18n.language === "ar";

  return (
    <div className="layout-wrapper">
      <div
        className=" left-strip"
        style={{
          marginLeft: isRTL ? "0" : "1%",
          marginRight: isRTL ? "1%" : "0",
          zIndex: 2,
        }}
      >
        {[...Array(25)].map((_, i) => (
          <img
            key={i}
            src={decoration}
            alt="Decoration"
            className=" strip-icon"
          />
        ))}
      </div>
      <div
        className="main-bg talent-search-height"
        // style={{
        //   minHeight: "83vh",
        // }}
      >
        <Header />
        {/* Banner Sec */}
        <div className="header-banner" id="home">
          <div
            className="container-fluid banner-txt"
            style={{ paddingTop: "140px", paddingBottom: "80px" }}
          >
            <h1
              className={`text-center fw-bolder res-size ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              style={{ fontSize: "70px" }}
            >
              {t("h_main_title.part1")}
              <img
                src={rocket}
                className="ms-2 rocket-animation"
                style={{ width: "35px" }}
                alt="rocket"
              />
            </h1>
            {/* <p
              className={`text-center fw-bold p-size ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
            >
              {t("h_main_second_line.part1")}
              <br
                className={`${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"} break`}
              />
              {t("h_main_second_line.part2")}
            </p> */}
          </div>
        </div>
        <div className="container talent-page-wrapper px-4 px-md-5"></div>
        {/*  */}
        <div
          className="container talentSearch sofia-font px-4 px-md-5 pb-5"
          style={{ borderRadius: "40px" }}
        >
          {/* Heading */}
          <div className="search-talent-heading mb-3">
            <h1 className="sofia-font">{t("new_text_15")}</h1>
          </div>

          {/* Filter Card */}
          <div className="card p-3 shadow-sm border-0">
            <div className="row g-3 align-items-end">
              {/* Skills */}
              <div className="col-6 col-lg" style={{ minWidth: "150px" }}>
                <label
                  className="form-label fw-bold"
                  style={{ fontSize: "18px" }}
                >
                  {t("new_text_3")}
                </label>
                <Select
                  isMulti
                  options={[...skills]
                    .sort((a, b) => {
                      const labelA =
                        i18n.language === "ar"
                          ? a.title_ar || a.title
                          : a.title;
                      const labelB =
                        i18n.language === "ar"
                          ? b.title_ar || b.title
                          : b.title;
                      return labelA.localeCompare(labelB);
                    })
                    .map((skill) => ({
                      value: skill._id,
                      label:
                        i18n.language === "ar"
                          ? skill.title_ar || skill.title
                          : skill.title,
                    }))}
                  value={filters.skills.map((id) => {
                    const skill = skills.find((s) => s._id === id);
                    return {
                      value: id,
                      label:
                        i18n.language === "ar"
                          ? skill?.title_ar || skill?.title
                          : skill?.title || "",
                    };
                  })}
                  onChange={(selected) => {
                    const ids = selected.map((option) => option.value);
                    setFilters((prev) => ({ ...prev, skills: ids }));
                  }}
                  placeholder={t("new_text_4")}
                  styles={{
                    control: (base) => ({
                      ...base,
                      height: 40,
                      minHeight: 40,
                      fontSize: 14,
                      borderRadius: 8,
                      border: "none",
                      boxShadow: "none",
                      backgroundColor: "white",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      display: "flex",
                      flexWrap: "nowrap",
                      overflow: "hidden",
                      padding: "0 8px",
                    }),
                    multiValue: (base) => ({
                      ...base,
                      backgroundColor: "#cd496d",
                      borderRadius: 4,
                      flexShrink: 0,
                      marginRight: 4,
                    }),
                    multiValueLabel: (base) => ({
                      ...base,
                      color: "white",
                      fontSize: 13,
                    }),
                    multiValueRemove: (base) => ({
                      ...base,
                      color: "white",
                      ":hover": {
                        backgroundColor: "#a03c58",
                        color: "white",
                      },
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: "#6c757d",
                    }),
                    menu: (base) => ({
                      ...base,
                      borderRadius: 8,
                      backgroundColor: "white",
                      fontSize: 14,
                      zIndex: 1050,
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isFocused
                        ? "rgba(65,19,24,0.08)"
                        : "white",
                      color: "#212529",
                      padding: "8px 10px",
                      cursor: "pointer",
                    }),
                  }}
                />
              </div>

              {/* Availability */}
              <div className="col-6 col-lg">
                <label
                  className="form-label fw-bold"
                  style={{ fontSize: "18px" }}
                >
                  {t("new_text_5")}
                </label>
                <DateRangePicker
                  initialSettings={{ minDate: moment().startOf("day") }}
                  onApply={(e, picker) => {
                    const start = picker.startDate?.format("MM-DD-YYYY");
                    const end = picker.endDate?.format("MM-DD-YYYY");
                    setFilters((prev) => ({
                      ...prev,
                      availability: [start, end],
                    }));
                  }}
                  autoUpdateInput={false}
                  opens="right"
                >
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t("new_text_14")}
                    readOnly
                    value={
                      filters.availability[0] && filters.availability[1]
                        ? `${filters.availability[0]} - ${filters.availability[1]}`
                        : ""
                    }
                    style={{
                      height: "40px",
                      fontSize: "14px",
                      padding: "0 12px",
                      borderRadius: "8px",
                      border: "none",
                      backgroundColor: "white",
                      boxShadow: "none",
                      color:
                        filters.availability[0] && filters.availability[1]
                          ? "#212529"
                          : "#6c757d",
                    }}
                  />
                </DateRangePicker>
              </div>

              {/* Nationality - Converted to React Select */}
              <div className="col-6 col-lg">
                <label
                  className="form-label fw-bold"
                  style={{ fontSize: "18px" }}
                >
                  {t("new_text_6")}
                </label>
                <Select
                  options={[
                    { value: "Arab", label: t("nationality_arab") },
                    { value: "Non Arab", label: t("nationality_non_arab") },
                    { value: "Emirati", label: t("nationality_emirati") },
                  ]}
                  value={
                    filters.nationality
                      ? {
                          value: filters.nationality,
                          label: filters.nationality,
                        }
                      : null
                  }
                  onChange={(selected) =>
                    handleFilterChange("nationality", selected?.value || "")
                  }
                  placeholder={t("new_text_13")}
                  isClearable
                  styles={{
                    control: (base) => ({
                      ...base,
                      height: 40,
                      minHeight: 40,
                      fontSize: 14,
                      borderRadius: 8,
                      border: "none",
                      boxShadow: "none",
                      backgroundColor: "white",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      padding: "0 8px",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: "#6c757d",
                    }),
                    menu: (base) => ({
                      ...base,
                      borderRadius: 8,
                      backgroundColor: "white",
                      fontSize: 14,
                      zIndex: 1050,
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isFocused
                        ? "rgba(65,19,24,0.08)"
                        : "white",
                      color: "#212529",
                      padding: "8px 10px",
                      cursor: "pointer",
                    }),
                  }}
                />
              </div>

              {/* Age Range - Converted to React Select */}
              <div className="col-6 col-lg">
                <label
                  className="form-label fw-bold"
                  style={{ fontSize: "18px" }}
                >
                  {t("new_text_7")}
                </label>
                <Select
                  options={[
                    { value: "0-5", label: "0-5" },
                    { value: "6-10", label: "6-10" },
                    { value: "11-15", label: "11-15" },
                    { value: "16-26", label: "16-26" },
                    { value: "27-40", label: "27-40" },
                    { value: "41+", label: "41+" },
                  ]}
                  value={
                    filters.ageRange
                      ? { value: filters.ageRange, label: filters.ageRange }
                      : null
                  }
                  onChange={(selected) =>
                    handleFilterChange("ageRange", selected?.value || "")
                  }
                  placeholder={t("new_text_11")}
                  isClearable
                  styles={{
                    control: (base) => ({
                      ...base,
                      height: 40,
                      minHeight: 40,
                      fontSize: 14,
                      borderRadius: 8,
                      border: "none",
                      boxShadow: "none",
                      backgroundColor: "white",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      padding: "0 8px",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: "#6c757d",
                    }),
                    menu: (base) => ({
                      ...base,
                      borderRadius: 8,
                      backgroundColor: "white",
                      fontSize: 14,
                      zIndex: 1050,
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isFocused
                        ? "rgba(65,19,24,0.08)"
                        : "white",
                      color: "#212529",
                      padding: "8px 10px",
                      cursor: "pointer",
                    }),
                  }}
                />
              </div>

              {/* Sort by Age - Converted to React Select */}
              <div className="col-6 col-lg">
                <label
                  className="form-label fw-bold"
                  style={{ fontSize: "18px" }}
                >
                  {t("new_text_9")}
                </label>
                <Select
                  options={[
                    { value: "asc", label: t("sort_asc") },
                    { value: "desc", label: t("sort_desc") },
                  ]}
                  value={
                    filters.ageSort
                      ? {
                          value: filters.ageSort,
                          label:
                            filters.ageSort === "asc"
                              ? "Lower to Higher"
                              : "Higher to Lower",
                        }
                      : null
                  }
                  onChange={(selected) =>
                    handleFilterChange("ageSort", selected?.value || "")
                  }
                  placeholder={t("new_text_10")}
                  isClearable
                  styles={{
                    control: (base) => ({
                      ...base,
                      height: 40,
                      minHeight: 40,
                      fontSize: 14,
                      borderRadius: 8,
                      border: "none",
                      boxShadow: "none",
                      backgroundColor: "white",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      padding: "0 8px",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: "#6c757d",
                    }),
                    menu: (base) => ({
                      ...base,
                      borderRadius: 8,
                      backgroundColor: "white",
                      fontSize: 14,
                      zIndex: 1050,
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isFocused
                        ? "rgba(65,19,24,0.08)"
                        : "white",
                      color: "#212529",
                      padding: "8px 10px",
                      cursor: "pointer",
                    }),
                  }}
                />
              </div>

              {/* Action Buttons */}
              {/* Action Buttons - Both in same column */}
              <div className="col-6 col-lg d-flex align-items-end gap-2">
                <button
                  className="btn btn-primary w-100"
                  style={{
                    height: "38px",
                    fontSize: "1rem",
                    lineHeight: "1.5",
                    padding: "0",
                    backgroundColor: "#FF5C35",
                    color: "#fff",
                    fontWeight: "500",
                    borderRadius: "15px",
                    border: "none",
                  }}
                  onClick={() => handleSearch()}
                >
                  {t("c_ff_text66")}
                </button>
                <button
                  className="btn w-100"
                  style={{
                    height: "38px",
                    fontSize: "1rem",
                    lineHeight: "1.5",
                    padding: "0",
                    backgroundColor: "#E5E4E4",
                    color: "#474747",
                    fontWeight: "500",
                    borderRadius: "15px",
                    border: "none",
                  }}
                  onClick={() => handleClearFilters()}
                >
                  {t("c_ff_text67")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Talent Cards */}

      <div className="  mb-5 mt-5">
        <div className="row">{/* {cardData.map((card, index) => ( */}</div>
        {isloading ? (
          <div className="d-flex justify-content-center align-items-center py-5">
            <p className="mb-0 text-muted">Loading…</p>
          </div>
        ) : talentsData?.length === 0 ? ( // ✅ use talentsData not recruitmentData
          <div className="text-center my-4">
            <div style={{ maxWidth: 200, margin: "0 auto" }}>
              <Lottie animationData={NoResultAnimation} loop={true} />
            </div>
          </div>
        ) : (
          <div className="talent-grid-wrapper ">
            <div className="talent-grid">
              {talentsData?.map((talent) => (
                <div className="talent-card-container" key={talent._id}>
                  {/* Image */}
                  <div className="talent-card-image">
                    <Image
                      src={talent?.picture}
                      alt={`${talent.first_name} ${talent.last_name}`}
                      className="talent-img"
                    />
                  </div>

                  {/* Name + Role */}
                  <div className="talent-card-info text-start ">
                    <h6 className="talent-name">
                      {talent.first_name} {talent.last_name}
                    </h6>
                    <p className="talent-role">
                      {(i18n.language === "ar"
                        ? talent.skills?.[0]?.skill_id?.title_ar ||
                          talent.skills?.[0]?.skill_id?.title
                        : talent.skills?.[0]?.skill_id?.title) || "Talent"}
                    </p>
                  </div>

                  {/* Hover Overlay */}
                  <div className="talent-card-hover">
                    <h6 className="talent-name text-white">
                      {talent.first_name} {talent.last_name}
                    </h6>

                    <p className="talent-role">
                      {(i18n.language === "ar"
                        ? talent.skills?.[0]?.skill_id?.title_ar ||
                          talent.skills?.[0]?.skill_id?.title
                        : talent.skills?.[0]?.skill_id?.title) || "Talent"}
                    </p>
                    {(talent?.nationality ||
                      talent?.country ||
                      talent?.country_flag) && (
                      <p className="text-white mb-2 small d-flex align-items-center gap-1 flex-wrap">
                        {/* Nationality */}
                        {talent?.nationality && (
                          <span>{talent.nationality}</span>
                        )}

                        {/* Comma (only if both nationality and country exist) */}
                        {talent?.nationality && talent?.country && (
                          <span>,</span>
                        )}

                        {/* Country Name */}
                        {talent?.country && <span>{talent.country}</span>}

                        {/* Country Flag */}
                        {talent?.country_flag && (
                          <img
                            src={talent.country_flag}
                            alt={`${talent.country || talent.nationality} flag`}
                            style={{
                              width: "18px",
                              height: "12px",
                              objectFit: "cover",
                              borderRadius: "2px",
                            }}
                          />
                        )}
                      </p>
                    )}

                    {talent.about && (
                      <p className="talent-about">
                        {talent.about.slice(0, 90)}
                        {talent.about.length > 90 ? "..." : ""}
                      </p>
                    )}

                    <Button
                      size="sm"
                      className="view-profile-btn min-w-[100px] px-3 whitespace-nowrap"
                      onClick={() => setShowPopup(true)}
                    >
                      {t("c_s_tab10")}
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}{" "}
      </div>

      {showPopup && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25 zindex"
          style={{ backdropFilter: "blur(2px)" }}
          onClick={() => setShowPopup(false)}
        >
          <div
            className="bg-white text-center p-4 rounded-4 shadow"
            style={{
              maxWidth: 500,
              width: "90%",
              boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
              animation: "scaleIn 0.3s ease-out",
            }}
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
          >
            {/* Icon */}
            <div className="mb-3">
              <div
                className="mx-auto d-flex justify-content-center align-items-center"
                style={{
                  background: "linear-gradient(135deg, #FFC107, #FF9800)",
                  width: 70,
                  height: 70,
                  borderRadius: "50%",
                  boxShadow: "0 4px 12px rgba(255, 152, 0, 0.4)",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="34"
                  height="34"
                  fill="white"
                  className="bi bi-exclamation-triangle-fill"
                  viewBox="0 0 16 16"
                  style={{
                    display: "block", // ✅ removes inline gaps
                  }}
                >
                  <path d="M7.938 2.016a.13.13 0 0 1 .125 0l6.857 11.856c.044.076.08.16.08.252a.5.5 0 0 1-.5.5H1.5a.5.5 0 0 1-.5-.5c0-.092.036-.176.08-.252L7.938 2.016zM8 5a.905.905 0 0 0-.9.9v3.6a.905.905 0 0 0 1.8 0V5.9A.905.905 0 0 0 8 5zm-.002 6.002a1.002 1.002 0 1 0 0 2.004 1.002 1.002 0 0 0 0-2.004z" />
                </svg>
              </div>
            </div>

            {/* Text */}
            <h5
              className={`fw-bold mb-2 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              style={{ fontWeight: 400 }}
            >
              {t("login_required_title")}
            </h5>
            <p
              className={`text-secondary mb-4 ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
              style={{ fontSize: 14, fontWeight: 400 }}
              dangerouslySetInnerHTML={{ __html: t("login_required_message") }}
            />

            {/* Buttons */}
            <div className="d-flex justify-content-center gap-3">
              {/* Close Button */}
              <button
                className={`px-4 py-2 fw-medium border rounded-pill ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                style={{
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  color: "#333",
                  fontSize: 16,
                  fontWeight: 400,
                  transition: "all 0.2s ease-in-out",
                }}
                onClick={() => setShowPopup(false)}
                onMouseOver={(e) =>
                  (e.currentTarget.style.backgroundColor = "#f8f9fa")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.backgroundColor = "#fff")
                }
              >
                {t("c_login_btn")}
              </button>

              {/* Login Button */}
              <Link
                to="/company/login"
                className={`text-decoration-none px-4 py-2 fw-medium rounded-pill ${i18n.language === "ar" ? "font-dishcek" : "font-iwanzaza"}`}
                style={{
                  backgroundColor: "#FF5C35",
                  color: "#fff",
                  fontSize: 16,
                  fontWeight: 400,
                  transition: "all 0.2s ease-in-out",
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.backgroundColor = "#e44d29")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.backgroundColor = "#FF5C35")
                }
              >
                {t("c_t_close")}
              </Link>
            </div>
          </div>

          {/* Animation Styles */}
          <style>{`
      @keyframes scaleIn {
        from { transform: scale(0.9); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
      }
    `}</style>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default SearchTalent;
